<template>
  <LlTosText v-if="isLawnlove" />
  <LsTosText v-else />
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import LlTosText from './LlTosText.vue';
import LsTosText from './LsTosText.vue';

export default {
  name: 'TOSModalText',
  components: { LlTosText, LsTosText },
  mixins: [themedComponentMixin],
};
</script>

<style lang="scss" scoped>
div:first-of-type {
  height: 50vh;
  overflow-y: auto;
  padding-right: 3px;
}

::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: $gray-secondary;
  border-radius: 3px;
}
</style>
